/**
 * @GENERATED from Figma node 3638:51944
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const DiscBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      fillRule="evenodd"
      d="M2 12c0 6.449 3.551 10 10 10s10-3.551 10-10S18.449 2 12 2 2 5.551 2 12m9.583-6.667c-4.03 0-6.25 2.22-6.25 6.25H7C7 8.5 8.5 7 11.583 7zm5.374 7.888c-.25 2.538-1.74 3.779-4.54 3.779v1.667c3.753 0 5.933-1.927 6.216-5.446zM12 14.5c-1.682 0-2.5-.818-2.5-2.5s.818-2.5 2.5-2.5 2.5.818 2.5 2.5-.818 2.5-2.5 2.5"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(DiscBright);
export { ForwardRef as DiscBright };
